export const ACCESS_LEVEL = Object.freeze({
  APPLICATION : 'application',
  TENANT      : 'tenant',
  INSTITUTION : 'institution'
});
